import ResourcesDispatcher from "../../config/ResourcesDispatcher";
const MULTIPLIERS_ANIMATIONS = {
    1: "1X",
    2: "2X",
    3: "3X",
    4: "4X",
    5: "5X",
    6: "10X",
    7: "20X",
    8: "50X"
};
const MULTIPLIERS_STATIC = {
    1: "1X_static",
    2: "2X_static",
    3: "3X_static",
    4: "4X_static",
    5: "5X_static",
    6: "10X_static",
    7: "20X_static",
    8: "50X_static"
};
class FreeSpinCell {
    constructor(_x, _y, index, reelIndex) {
        this.on = true;
        this.memo = 0;
        this.reelIndex = reelIndex;
        this.freeSpinReel = null;
        this.index = index;
        let cellGeom = layoutBuilder.getNodeByPath(`FreeSpin/grid/reels/reel_${this.reelIndex}/cell_${index}/cell#geom`);
        this.freeSpinSymbolImageRaw = ResourcesDispatcher.GAME_CONSTANTS.FS_SYMBOL_OFF;
        this.freeSpinSymbolSpineRaw = ResourcesDispatcher.SPINES.Moltiplicatori;
        this.freeSpinSymbolImage = scene.add.image(cellGeom?.phaser.display?.x, cellGeom?.phaser.display?.y, this.freeSpinSymbolImageRaw.key, this.freeSpinSymbolImageRaw.frame).setTint(0x7F7F7F)
            .setOrigin(cellGeom?.phaser.display?.originX, cellGeom?.phaser.display?.originY);
        this.freeSpinSymbolSpine = scene.add.spine(cellGeom?.phaser.display?.x, cellGeom?.phaser.display?.y, this.freeSpinSymbolSpineRaw.jsonKey, this.freeSpinSymbolSpineRaw.atlasKey).setOrigin(cellGeom?.phaser.display?.originX, cellGeom?.phaser.display?.originY).setVisible(false);
        this.freeSpinContainer = scene.add.container(0, 0, [this.freeSpinSymbolImage, this.freeSpinSymbolSpine]).setVisible(false);
        this.container = layoutBuilder.findByPath(`FreeSpin/grid/reels/reel_${this.reelIndex}/cell_${index}`);
        this.container.add(this.freeSpinContainer);
    }
    /** PUBLIC GETTERS **/
    getOn() {
        return this.on;
    }
    getMemo() {
        return this.memo;
    }
    getContainer() {
        return this.container;
    }
    getIndex() {
        return this.index;
    }
    /*******************/
    setMemo(memo) {
        this.memo = memo;
    }
    setIndex(index) {
        this.index = index;
    }
    setOn(on) {
        this.on = on;
    }
    turnOn() {
        this.on = true;
    }
    turnOff() {
        this.on = false;
    }
    setFreeSpinReel(freeSpinReel) {
        this.freeSpinReel = freeSpinReel;
    }
    refreshInternalPositions() {
        const cellGeom = layoutBuilder.getNodeByPath(`FreeSpin/grid/reels/reel_${this.reelIndex}/cell_${this.index}/cell#geom`);
        if (!cellGeom)
            return;
        const x = cellGeom.phaser?.display?.x ?? 0;
        const y = cellGeom.phaser?.display?.y ?? 0;
        const originX = cellGeom.phaser?.display?.originX ?? 0.5;
        const originY = cellGeom.phaser?.display?.originY ?? 0.5;
        this.freeSpinSymbolImage.setPosition(x, y).setOrigin(originX, originY);
        this.freeSpinSymbolSpine.setPosition(x, y).setOrigin(originX, originY);
    }
    resetLayer() {
        if (!this.freeSpinReel) {
            return;
        }
        if (!this.freeSpinReel.getContainer().exists(this.container)) {
            this.freeSpinReel.getContainer().add(this.container);
        }
    }
    showFrame() { }
    hideFrame() { }
    checkLayer() { }
    setCellInfo(cellMemo) {
        this.freeSpinContainer.setVisible(true);
        this.freeSpinSymbolImage.setVisible(true);
        const memo = ResourcesDispatcher.GAME_CONSTANTS.MAP_FREESPIN_MEMO_TO_GC_MEMO[cellMemo] ?? 0; // fallback to 0 if not mapped
        this.setMemo(memo);
        if (this.getMemo() !== 0) {
            // Mostra spine con animazione STATICA come "posa"
            this.freeSpinSymbolImage.setVisible(false);
            this.freeSpinSymbolSpine.setVisible(true);
            const staticAnimationName = MULTIPLIERS_STATIC[this.getMemo()];
            if (staticAnimationName) {
                // Usa l'animazione statica (es. "1X_static") come posa iniziale
                this.freeSpinSymbolSpine.animationState.setAnimation(0, staticAnimationName, false);
            }
        }
        else {
            // Simbolo vuoto
            this.freeSpinSymbolSpine.setVisible(false);
            this.freeSpinSymbolImage.setVisible(true);
            this.freeSpinSymbolImage.setTexture(this.freeSpinSymbolImageRaw.key, this.freeSpinSymbolImageRaw.frame);
        }
    }
    playAnimation(loop = false) {
        return new Promise((resolve) => {
            // Guard clause 1: Nessun moltiplicatore
            if (this.getMemo() === 0) {
                this.freeSpinSymbolSpine.setVisible(false);
                resolve(true);
                return;
            }
            // Guard clause 2: Animazione non trovata
            const animationName = MULTIPLIERS_ANIMATIONS[this.getMemo()];
            if (!animationName) {
                resolve(true);
                return;
            }
            this.freeSpinSymbolSpine.setVisible(true);
            const trackEntry = this.freeSpinSymbolSpine.animationState.setAnimation(FreeSpinCell.WinAnimationTrack, animationName, loop);
            trackEntry.alpha = FreeSpinCell.WinAnimationAlpha;
            if (loop) {
                resolve(true);
            }
            else {
                trackEntry.listener = {
                    complete: () => {
                        const staticAnimationName = MULTIPLIERS_STATIC[this.getMemo()];
                        if (staticAnimationName) {
                            this.freeSpinSymbolSpine.animationState.setAnimation(0, staticAnimationName, false);
                        }
                        resolve(true);
                    }
                };
            }
        });
    }
}
FreeSpinCell.OnOffAnimationTrack = 0;
FreeSpinCell.WinAnimationTrack = 0;
FreeSpinCell.OnOffAnimationAlpha = 1;
FreeSpinCell.WinAnimationAlpha = 1;
export default FreeSpinCell;
